import Vue from "vue";
import request from "./config/http.js";
import params from "./config/params.js";
// axios 0.22以下，用于取消请求
import axios from "axios";
import global from "@/core/global/global.js";
import HTTP from "./config/api.js";
const CancelToken = axios.CancelToken;

const assignUrl = "/sys/reviewAllocation/assign"; //初审分配 —— 人员分配
const batchAssignUrl = "/sys/reviewAllocation/batchAssign"; //初审分配 —— 批量分配
const listUrl = "/sys/reviewAllocation/list"; //初审分配列表
const oneKeyAssignUrl = "/sys/reviewAllocation/oneKeyAssign"; //初审分配 —— 一键分配
const reviewStatusUrl = "/sys/reviewAllocation/reviewStatus"; //初审分配 —— 稿件状态下拉
const saveAssignUrl = "/sys/reviewAllocation/saveAssign"; //初审分配 ——  保存/调整人员分配\

const addFirstAuditRecordingUrl = "/sys/review/addFirstAuditRecording"; //提交初审意见信息
const editExportBillUrl = "/sys/review/editExportBill"; //采编 —— 导出开票信息(纸质发票)
const editExportElectronBillUrl = "/sys/review/editExportElectronBill"; //采编 —— 导出开票信息(电子发票)
const editInvoiceListUrl = "/sys/review/editInvoiceList"; //采编发票管理列表
const listUrl1 = "/sys/review/list"; //初审 —— 初审列表
const queryCompleteReviewUrl = "/sys/review/queryCompleteReview"; //初审完成 —— 查看审核状态

const downloadArticleUrl = "/sys/download/downloadArticle"; //稿件初审下载
const zipUrl = "/sys/common/zip"; //批量下载

const addReviewTemplateUrl = "/sys/reviewTemplate/addReviewTemplate"; //添加审核模板
const queryReviewTemplateUrl = "/sys/reviewTemplate/queryReviewTemplate"; //审核模板列表
const reviewTemplateDetailUrl = "/sys/reviewTemplate/reviewTemplateDetail"; //查看模板详情信息
const delReviewTemplateUrl = "/sys/reviewTemplate/delReviewTemplate"; //删除审核模板

const adjustReauditUserUrl = "/sys/reauditAllot/adjustReauditUser"; //单个调整复审人员分配
const aKeyDistributionUrl = "/sys/reauditAllot/aKeyDistribution"; //复审一键分配
const distributionReauditUserUrl = "/sys/reauditAllot/distributionReauditUser"; //单个分配复审人员
const queryReauditAllotListUrl = "/sys/reauditAllot/queryReauditAllotList"; //复审分配列表
const queryReauditStatusInfoUrl = "/sys/reauditAllot/queryReauditStatusInfo"; //复审分配稿件状态查询用
const queryReauditUserUrl = "/sys/reauditAllot/queryReauditUser"; //查询复审人员，回显用
const adjustReauditUserForMultipleUrl =
  "/sys/reauditAllot/adjustReauditUserForMultiple"; //多选人员分配

const periodDepartureListUrl = "/sys/periodicalDeparture/periodDepartureList"; //刊期待发排列表
const getTypeSetListUrl = "/sys/periodicalDeparture/getTypeSetList"; //获取分配专员列表
const distributionTypeSetUrl = "/sys/periodicalDeparture/distributionTypeSet"; //点击进行分配
const updateTypeSetUrl = "/sys/periodicalDeparture/updateTypeSet"; //点击调整分配专员

const queryProofreadListUrl = "/sys/typesetting/queryProofreadList"; //排版刊期列表
const zip15Url = "/sys/common/zip15"; //zip打包下载(初排)
const updateProofreadUrl = "/sys/typesetting/updateProofread"; //排版刊期状态修改
const queryOutFilmListUrl = "/sys/OutFilm/queryOutFilmList"; //出片改片印刷列表
const downloadPdfUrl = "/sys/download/downloadPdf"; //pdf下载

const outFilmUrl = "/sys/OutFilm/outFilm"; //出片
const alterFilmUrl = "/sys/OutFilm/alterFilm"; //改片
const printingUrl = "/sys/OutFilm/printing"; //印刷
const threeChangesUrl = "/sys/typesetting/threeChanges"; //三改上传PDF成功后修改刊期状态
const uploadPdfUrl = "/sys/OutFilm/uploadPdf"; //上传pdf 

const queryAuthorPostListUrl = "/sys/periodPost/queryAuthorPostList"; //发行邮寄列表
const updatePostInfoUrl = "/sys/periodPost/updatePostInfo"; //修改
const updateChannel = "/sys/periodArticleScheduling/updateChannel"; //栏目修改
const elective = "/sys/articleEmploy/updateAuditatusById"; // 已录用稿件退修到初审阶段

const downloadAnnexesZipUrl = "/sys/download/downloadAnnexs"; // 下载稿件附件zip包

let dev = "/tsg-admin"; //公共请求头
const apis = {
  // 已录用稿件退修退稿审核
  elective(data) {
    return request({
      url: dev + elective,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 栏目修改
  updateChannel(data) {
    return request({
      url: dev + updateChannel,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //初审分配
  countList(data) {
    return request({
      url: dev + "/sys/reviewAllocation/countList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //人员分配
  assign(data) {
    return request({
      url: dev + assignUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //批量分配
  batchAssign(data) {
    return request({
      url: dev + batchAssignUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //初审分配列表
  list(data) {
    return request({
      url: dev + listUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //一键分配
  oneKeyAssign(data) {
    return request({
      url: dev + oneKeyAssignUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //稿件状态下拉
  reviewStatus(data) {
    return request({
      url: dev + reviewStatusUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //保存/调整人员分配
  saveAssign(data) {
    return request({
      url: dev + saveAssignUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //初审 —— 提交初审意见信息
  addFirstAuditRecording(data) {
    return request({
      url: dev + addFirstAuditRecordingUrl,
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //采编 —— 导出开票信息(纸质发票)
  editExportBill(data) {
    return request({
      url: dev + editExportBillUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //采编 —— 导出开票信息(电子发票)
  editExportElectronBill(data) {
    return request({
      url: dev + editExportElectronBillUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //采编发票管理列表
  editInvoiceList(data) {
    return request({
      url: dev + editInvoiceListUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //初审完成 —— 查看审核状态
  queryCompleteReview(data) {
    return request({
      url: dev + queryCompleteReviewUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //初审列表
  list1(data) {
    return request({
      url: dev + listUrl1,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  downloadArticle(data) {
    //单个下载
    return request({
      url: dev + downloadArticleUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //批量下载
  zip(data) {
    return request({
      url: dev + zipUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //批量下载-2022/09/28 新增三审，录用批量下载
  zipdownload(data) {
    return request({
      url: dev + "/sys/common/zipDownload",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result);
    });
  },
  //添加审核模板
  addReviewTemplate(data) {
    return request({
      url: dev + addReviewTemplateUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //模板列表
  queryReviewTemplate(data) {
    return request({
      url: dev + queryReviewTemplateUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //模板信息
  reviewTemplateDetail(data) {
    return request({
      url: dev + reviewTemplateDetailUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //集团禁用、启用
  delReviewTemplate(data) {
    return request({
      url: dev + delReviewTemplateUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //单个调整复审人员分配
  adjustReauditUser(data) {
    return request({
      url: dev + adjustReauditUserUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //复审一键分配
  aKeyDistribution(data) {
    return request({
      url: dev + aKeyDistributionUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //单个分配复审人员
  distributionReauditUser(data) {
    return request({
      url: dev + distributionReauditUserUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //复审分配列表
  queryReauditAllotList(data) {
    return request({
      url: dev + queryReauditAllotListUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //复审分配稿件状态查询用
  queryReauditStatusInfo(data) {
    return request({
      url: dev + queryReauditStatusInfoUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //复审分配（包含工作量）
  queryCountList(data) {
    return request({
      url: dev + "/sys/reauditAllot/queryCountList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //复审分配稿件状态查询用
  queryReauditUser(data) {
    return request({
      url: dev + queryReauditUserUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //多选分配复审人员
  adjustReauditUserForMultiple(data) {
    return request({
      url: dev + adjustReauditUserForMultipleUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 终审分配（包含工作量）
  queryFinalCountList(data) {
    return request({
      url: dev + "/sys/finalAllot/queryFinalCountList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //刊期待发排列表
  periodDepartureList(data) {
    return request({
      url: dev + periodDepartureListUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //获取分配专员列表
  getTypeSetList(data) {
    return request({
      url: dev + getTypeSetListUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //点击进行分配
  distributionTypeSet(data) {
    return request({
      url: dev + distributionTypeSetUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //点击进行调整
  updateTypeSet(data) {
    return request({
      url: dev + updateTypeSetUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //排版刊期列表
  queryProofreadList(data) {
    return request({
      url: dev + queryProofreadListUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //zip打包下载(初排)
  zip15(data) {
    return request({
      url: dev + zip15Url,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 排版刊期状态修改
  updateProofread(data) {
    return request({
      url: dev + updateProofreadUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //出片改片印刷列表
  queryOutFilmList(data) {
    return request({
      url: dev + queryOutFilmListUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //审读、改红列表
  readAndChangeToRedPage(data) {
    return request({
      url: dev + "/sys/readAndChangeToRed/readAndChangeToRedPage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //审读、改红完成列表
  readAndChangeCompletePage(data) {
    return request({
      url: dev + "/sys/readAndChangeToRed/completePage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //审读、改红批量下载
  readAndChangeBatchDownload(data) {
    return request({
      url: dev + "/sys/readAndChangeToRed/batchDownload",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //审读、改红审核
  readAndChangeToRedAudit(data) {
    return request({
      url: dev + "/sys/readAndChangeToRed/audit",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //审读、改红完成查看记录
  readAndChangeViewRecords(data) {
    return request({
      url: dev + "/sys/readAndChangeToRed/viewRecords",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //pdf下载
  downloadPdf(data) {
    return request({
      url: dev + downloadPdfUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //出片
  outFilm(data) {
    return request({
      url: dev + outFilmUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //改片
  alterFilm(data) {
    return request({
      url: dev + alterFilmUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //三改上传PDF成功后修改刊期状态
  threeChanges(data) {
    return request({
      url: dev + threeChangesUrl,
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //pdf上传
  uploadPdf(data) {
    return request({
      url: dev + uploadPdfUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // v3.0.0 
  // /sys/proofread/proofreadDetailSum校对绩效统计明细
  proofreadDetailSum(data) {
    return request({
      url: dev + '/sys/proofread/proofreadDetailSum',
      method: "get",
      params: data, 
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
 
  
  //印刷
  printing(data) {
    return request({
      url: dev + printingUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //发行邮政列表
  queryAuthorPostList(data) {
    return request({
      url: dev + queryAuthorPostListUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //发行邮政修改
  updatePostInfo(data) {
    return request({
      url: dev + updatePostInfoUrl,
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //审核退修推荐文献列表
  queryRecommend(data) {

    return request({
      url: dev + "/sys/Editing/queryRecommend",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 审核退修，添加推荐文献，获取 /api/queryArticleIdList 根据稿件ID获取该稿件投稿人信息（大数据接口）-- v3.0.3去除该接口
  queryArticleKeyword(data) {
    return request({
      url: dev + "/api/queryArticleIdList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 表格中添加上传按钮，传递更新后的文件路径
  updateArticlePath(data) {
    return request({
      // url: dev + "/api/updateArticlePath",
      // 2022/09/19 修改稿件更新接口
      url: dev + "/sys/review/updateArticlePath",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 表格中添加上传按钮，传递更新后的文件路径
  readAndChangeUpdateArticlePath(data) {
    return request({
      url: dev + "/sys/readAndChangeToRed/upload",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 2022/09/19 新增word转pdf接口，三审点击审核进入在线预览时调用。参数需传递articleId
  wordToPdf(data) {
    return request({
      url: dev + "/api/updateWordToPdf",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 2022/10/17 新增获取三审自定义审核项接口，填写审核意见时获取
  getCustomAuditOptions(data) {
    return request({
      url: dev + "/sys/processTurnk/getCustom",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 下载稿件附件zip包
  downloadAnnexesZip(data) {
    return request({
      url: dev + downloadAnnexesZipUrl,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result);
    });
  },

  //2022-12 v2.6.1 新增外审自定义审核 /sys/expertAudit/getOpenExpert审核稿件时查询是否申请外审
  getOpenExpertStatus(data) {
    return request({
      url: dev + "/sys/expertAudit/getOpenExpert",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 审核稿件时查询是否申请外审2025/05/15修改接口
  getArtApplyExpertStatus(data) {
    return request({
      url: dev + "/sys/expertAudit/getArtApplyExpertStatus",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 申请专家外审，保存学科领域 /sys/expertAudit/auditDirection外审研究领域保存
  saveExpertSubjects(data) {
    return request({
      url: dev + "/sys/expertAudit/auditDirection",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 取消外审 /sys/expertAudit/cancelAudit
  cancelExpertAudit(data) {
    return request({
      url: dev + "/sys/expertAudit/cancelAudit",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // /sys/expertAudit/getAuditStatus查询稿件该稿件是否正在外审中
  getAuditStatus(data) {
    return request({
      url: dev + "/sys/expertAudit/getAuditStatus",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 查询会议拦截
  getMeetingIntercept(data) {
    return request({
      url: dev + "/sys/pub/meetingIntercept",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // /sys/expertAudit/judgeButton 判断查看外审记录按钮与未完成外审按钮显示
  getAuditProcess(data) {
    return request({
      url: dev + "/sys/expertAudit/judgeButton",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // /sys/expertAudit/getAuditInfoList 查看外审记录,
  getExpertAuditRecords(data) {
    return request({
      url: dev + "/sys/expertAudit/getAuditInfoList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // v2.8.1 新增补充附件接口 /sys/expertAudit/getAnnexOpen 三审审核稿件补充附件按钮是否显示
  // 审核稿件补充附件按钮是否显示，2显示待上传附件，1显示补充附件，0不显示补充附件
  getSupplementAnnexOpen(data) {
    return request({
      url: dev + "/sys/expertAudit/getAnnexOpen",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // /sys/expertAudit/saveAnnexApply 让作者补充附件,
  //v3.0.4  /sys/expertAudit/saveAnnexApply 让作者补充附件-3.0.4
  saveSupplementAnnexApply(data) {
    return request({
      // url: dev + "/sys/expertAudit/saveAnnexApply",
      url: dev + "/sys/expertAudit/saveAnnexApply", //v3.0.4 
      method: "post",
      // method: "get",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // start 终审分配相关--------------------
  // 0. /sys/finalAllot/queryFinalUser 查询终审分配人员
  queryFinalAuditUser(data) {
    return request({
      url: dev + "/sys/finalAllot/queryFinalUser",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 1./sys/finalAllot/queryFinalAllotList 终审分配列表
  finalAllocArticleList(data) {
    return request({
      url: dev + "/sys/finalAllot/queryFinalAllotList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 2./sys/finalAllot/queryFinalCountList 终审采编统计,
  finalAllocEditsList(data) {
    return request({
      url: dev + "/sys/finalAllot/queryFinalCountList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 3./sys/finalAllot/queryFinalStatusInfo 终审分配稿件状态查询用,
  finalAllocArticleStatus(data) {
    return request({
      url: dev + "/sys/finalAllot/queryFinalStatusInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 4./sys/finalAllot/queryFinalUser 查询终审人员，回显用
  finalAllocUser(data) {
    return request({
      url: dev + "/sys/finalAllot/queryFinalUser",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 5./sys/finalAllot/distributionFinalUser单个分配终审人员,
  distributionFinalUser(data) {
    return request({
      url: dev + "/sys/finalAllot/distributionFinalUser",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 6./sys/finalAllot/justFinalUser单个调整终审人员分配
  changeDistributionFinalUser(data) {
    return request({
      url: dev + "/sys/finalAllot/justFinalUser",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 7./sys/finalAllot/justFinalUserForMultiple多选分配终审人员
  distributionFinalMultiple(data) {
    return request({
      url: dev + "/sys/finalAllot/justFinalUserForMultiple",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 8./sys/finalAllot/keyFinalDistribution终审一键分配,
  distributionFinalIntelligent(data) {
    return request({
      url: dev + "/sys/finalAllot/keyFinalDistribution",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // end 终审分配相关--------------------
  // start  2023/11 v2.9.5 校样（原清样功能）相关  ----------
  // 1./sys/artProof/list 校样状态列表(无须参数)
  articleProofStatus() {
    return request({
      url: dev + "/sys/artProof/list",
      method: "get",
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 2.待校样列表 /sys/artProof/page 待清样列表
  unproofedDataList(data) {
    return request({
      url: dev + "/sys/artProof/page",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 3.操作
  // 3.1 /sys/artProof/ignore 单个忽略
  ignoreArticleProof(data) {
    return request({
      url: dev + "/sys/artProof/ignore",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 3.2 /sys/artProof/finalProof 单个清样
  articleProof(data, that) {

    return request({
      url: dev + "/sys/artProof/finalProof",
      method: "get",
      params: data,

    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 批量忽略 /sys/artProof/batchIgnore
  batchIgnore(data) {
    return request({
      url: dev + "/sys/artProof/batchIgnore",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 确认改期校样 /sys/artProof/confirmProof
  confirmPeriodProof(data) {
    return request({
      url: dev + "/sys/artProof/confirmProof",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //   /sys/artProof/batchFinalProof
  batchFinalProof(data) {

    return request({
      url: dev + "/sys/artProof/batchFinalProof",
      method: "post",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
      dataType: "formData"

    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //  /sys/artProof/detail 查看详情
  proofDetail(data) {
    return request({
      url: dev + "/sys/artProof/detail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 4.已校样数据列表
  proofedDataList(data) {
    return request({
      url: dev + "/sys/artProof/completePage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // /sys/artProof/periodList 获取未校样刊期列表
  unproofedPeriodicalList(data) {
    return request({
      url: dev + "/sys/artProof/periodList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //  /sys/artProof/periodNameList 获取已校样刊期列表
  proofedPeriodicalList(data) {
    return request({
      url: dev + "/sys/artProof/periodNameList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  periodicalPost(data) {
    return request({
      url: dev + "/sys/periodPost/periodicalPost",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  //快递公司
  // expressCompany(data) {
  //   return request({
  //     url:global.url3 + "/zw-logistics/expressCompany/nf/list",
  //     method: "get",
  //     params: data,
  //   }).then((result) => {
  //     return Promise.resolve(result.data);
  //   });
  // },
  expressCompany(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-logistics/expressCompany/nf/list",
      data,
      false
    );
  },
  detailByPayBatchId(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-logistics/orderExpress/nf/detailByPayBatchId",
      data,
      false
    );
  },

  //筛稿分配 —— 人员分配名单
  screenAssign(data) {
    return request({
      url: dev + "/sys/screeningAllocation/assign",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //筛稿分配 —— 统计
  screenCountList(data) {
    return request({
      url: dev + "/sys/screeningAllocation/countList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 筛稿分配 —— 批量分配
  screenBatchAssign(data) {
    return request({
      url: dev + "/sys/screeningAllocation/batchAssign",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 筛稿分配 —— 一键分配
  screenOneKeyAssign(data) {
    return request({
      url: dev + "/sys/screeningAllocation/oneKeyAssign",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 筛稿分配 —— 保存/调整人员分配
  screenSaveAssign(data) {
    return request({
      url: dev + "/sys/screeningAllocation/saveAssign",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 筛稿分配 —— 保存/调整人员分配
  screenList(data) {
    return request({
      url: dev + "/sys/screeningAllocation/list",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 筛稿分配 —— 稿件状态下拉
  screenReviewStatus(data) {
    return request({
      url: dev + "/sys/screeningAllocation/screeningStatus",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // start ------------v3.0.4 附件审核--------------
  // 1. /sys/annexAudit/annexStatusList 待审核-附件状态下拉-3.0.4
  annexStatusList(data) {
    return request({
      url: dev + "/sys/annexAudit/annexStatusList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
   // 2. /sys/annexAudit/annexAuditList 已审核-审核状态下拉-3.0.4
   annexAuditList(data) {
    return request({
      url: dev + "/sys/annexAudit/annexAuditList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
    // 3. /sys/annexAudit/auditDetail 附件审核-审核详情-3.0.4
    auditDetail(data) {
      return request({
        url: dev + "/sys/annexAudit/auditDetail",
        method: "get",
        params: data,
      }).then((result) => {
        return Promise.resolve(result.data);
      });
  },
     // 4. /sys/annexAudit/auditPage 审核列表-3.0.4
     auditPage(data) {
    return request({
      url: dev + "/sys/annexAudit/auditPage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
    // 5./sys/annexAudit/ignore 附件审核-忽略-3.0.4
    ignoreAnnexAudit(data) {
      return request({
        url: dev + "/sys/annexAudit/ignore?"+data,
        method: "get",
        // params: data,
      }).then((result) => {
        return Promise.resolve(result.data);
      });
  },
     // 6. /sys/annexAudit/pass 附件审核-审核通过-3.0.4
   passAnnexAudit(data) {
    return request({
      url: dev + "/sys/annexAudit/pass?"+data,
      method: "get",
      // params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
    // 7. /sys/annexAudit/supplementAnnex 附件审核-补充附件-3.0.4
    supplementAnnex(data) {
      return request({
        url: dev + "/sys/annexAudit/supplementAnnex?"+data,
        method: "get",
        // params: data,
        paramsSerilize:true
      }).then((result) => {
        return Promise.resolve(result.data);
      });
    },
   // end ------------v3.0.4 附件审核--------------

  // v3.0.4 稿件查询附件补充-提醒作者补充
    
// /sys/operation/remindUser提醒用户补充
remindUserSupplementAnnex(data) {
  return request({
    url: dev + "/sys/operation/remindUser",
    method: "get",
    params: data,
  }).then((result) => {
    return Promise.resolve(result.data);
  });
  },
  /* v3.0.6 付印 ********************* 开始 */
  // 1、/sys/OutFilm/periodYearList 根据期刊id获取刊期年份
  periodYearList(data) {
    return request({
      url: dev + "/sys/OutFilm/periodYearList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 2、 /sys/OutFilm/uploadZip 3.0.6付印上传的ZIP文件路径
  uploadZip(data) {
    return request({
      url: dev + "/sys/OutFilm/uploadZip",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 3、/sys/OutFilm/pressting 3.0.6付印
  pressting(data) {
    return request({
      url: dev + "/sys/OutFilm/pressting",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 4、 /sys/OutFilm/printing 3.0.6印刷
  printing(data) {
    return request({
      url: dev + "/sys/OutFilm/printing",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 5、 /sys/OutFilm/queryPrintingCompleteList 3.0.6印刷完成列表
  queryPrintingCompleteList(data) {
    return request({
      url: dev + "/sys/OutFilm/queryPrintingCompleteList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //省市
  provinceCityTree(data) {
    return HTTP.get(
      global.global.url4 + "/tsg-author/web/common/provinceCityTree",
      data,
      false
    );
  },

/* v3.0.6 付印 ********************* 结束 */

};

export default apis;



// WEBPACK FOOTER //
// ./src/core/api/editorialReview.serve.js